import LooksSimilarItemsFailure from "./LooksSimilarItemsFailure";
import { UNAMUSED } from "../../faceEmoji";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";

const LooksSimilarItemsNoItems = () => {
  const { getTranslation } = useRuntimeConstants();

  return (
    <LooksSimilarItemsFailure
      titleTranslationKey="similar_items_no_results_title"
      subTitleTranslationKey="similar_items_no_results_subtitle"
      emojiType={UNAMUSED}
      ariaLabel={getTranslation("emoji_face_unamused")}
    />
  );
};
export default LooksSimilarItemsNoItems;
